module.exports = __webpack_public_path__ + "48872c17188673dde9c728aa6d8f680e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-police-s.png
// module id = 1965
// module chunks = 0